// Webpack polyfills for Node.js modules — browser-safe shims
// Avoid using `require` or `import` so this file can be loaded as a plain
// script (it's included in `angular.json` `scripts` and runs in the browser).

// Minimal `querystring` shim using URLSearchParams
;(function () {
	function stringify(obj: { [k: string]: any }): string {
		const params = new URLSearchParams();
		Object.keys(obj || {}).forEach((k) => {
			const v = obj[k];
			if (Array.isArray(v)) {
				v.forEach((item) => params.append(k, String(item)));
			} else if (v !== undefined && v !== null) {
				params.append(k, String(v));
			}
		});
		return params.toString();
	}

	function parse(str: string): { [k: string]: any } {
		const s = (str || '').replace(/^\?/, '');
		const params = new URLSearchParams(s);
		const out: { [k: string]: any } = {};
		// `URLSearchParams.entries()` may not be available in the project's lib/DOM
		// typings under older TypeScript versions. Use `forEach` which is widely
		// supported on URLSearchParams to avoid TS errors.
		params.forEach((v, k) => {
			if (out.hasOwnProperty(k)) {
				if (!Array.isArray(out[k])) out[k] = [out[k]];
				out[k].push(v);
			} else {
				out[k] = v;
			}
		});
		return out;
	}

	(window as any)['querystring'] = { parse: parse, stringify: stringify };
})();

// Minimal `process` shim
if (!(window as any).process) {
	(window as any).process = ({ env: {} } as any);
}

// Minimal `Buffer` shim sufficient for common usages of `Buffer.from(string)`
;(function () {
	if ((window as any)['Buffer']) return;

	function _toUint8ArrayFromString(str: string): Uint8Array {
		return new TextEncoder().encode(str);
	}

	function from(input: any, encoding?: string) {
		if (typeof input === 'string') {
			if (encoding === 'base64') {
				// decode base64 string to binary
				const binary = atob(input);
				const arr = new Uint8Array(binary.length);
				for (let i = 0; i < binary.length; i++) arr[i] = binary.charCodeAt(i);
				const buf = arr;
				return {
					_buf: buf,
					toString(enc?: string) {
						if (enc === 'base64') {
							let s = '';
							for (let i = 0; i < buf.length; i++) s += String.fromCharCode(buf[i]);
							return btoa(s);
						}
						return new TextDecoder().decode(buf);
					},
					length: buf.length,
				};
			}
			const buf = _toUint8ArrayFromString(input);
			return {
				_buf: buf,
				toString(enc?: string) {
					return new TextDecoder().decode(buf);
				},
				length: buf.length,
			};
		}
		if (input instanceof ArrayBuffer) {
			const buf = new Uint8Array(input);
			return { _buf: buf, toString() { return new TextDecoder().decode(buf); }, length: buf.length };
		}
		if (Array.isArray(input) || input instanceof Uint8Array) {
			const buf = new Uint8Array(input as any);
			return { _buf: buf, toString() { return new TextDecoder().decode(buf); }, length: buf.length };
		}
		return input;
	}

	(window as any)['Buffer'] = { from: from, isBuffer: (b: any) => !!(b && b._buf && b._buf.buffer instanceof ArrayBuffer) };
})();
